import { AxiosMethod } from "../entities/Environment";
import request from "../axios/axios";
import {
  CreateMixPlatformInterface,
  TenantCredentialsInterface,
} from "../entities/Tenant";

export enum PlatformEndpoints {
  PLATFORM_SETTING = "platform/setting",
  PLATFORM_MIX = "platform/mix",
}

export class PlatformService {
  static platformInit(data: {
    url: string;
  }): Promise<TenantCredentialsInterface> {
    return request({
      url: PlatformEndpoints.PLATFORM_SETTING,
      method: AxiosMethod.POST,
      data,
    });
  }

  static createMix(data: CreateMixPlatformInterface) {
    return request({
      url: PlatformEndpoints.PLATFORM_MIX,
      method: AxiosMethod.POST,
      data,
    });
  }
}
